app.farmnetControllers.addCustomCode('fertilizerCoreController', function(
  $scope,
  controller,
  $injector
) {
  var coreUnitService = $injector.get('coreUnitService'),
    searchService = $injector.get('search.service'),
    originalOptions;

  //custom header forfertilizer auto complete box
  $scope.customHeaderTemplate = require('./fertilizerCoreCustomHeader.html');

  $scope.$watch('details.fertilizer.unit', function(newVal, oldVal) {
    if (newVal !== oldVal && $scope.details) {
      coreUnitService.updateOptions($scope.details.fertilizer, originalOptions);
    }
  });

  function initFertiwebCode(model) {
    const availableCodes = $scope.ctrl.fertiwebCodeOptions.map(option => option.code)

    let vendorId = undefined;
    let vendorProductId = undefined;

    if(model) {
      vendorId = model.vendorId;
      vendorProductId = model.vendorProductId;
    }

    const fertiwebCode = vendorId === "FERTIWEB" && availableCodes.indexOf(vendorProductId) !== -1 ? vendorProductId : '';
    model.fertiwebCode = fertiwebCode
  }

  ang.overrideFunction(controller, 'onAfterLoad', function(baseFn, model) {
    baseFn(model); //super()

    //store original options (a copy)
    originalOptions = model.fertilizer.stockyardDisplayUnitOptions.slice();

    //init
    coreUnitService.updateOptions($scope.details.fertilizer, originalOptions);

    initFertiwebCode(model.fertilizer)
  });

  ang.overrideFunction(controller, 'toSaveModel', function(baseFn, model) {
    model = baseFn(model);

    if (model) {
      // Prevent save if we change these fields
      delete model.fertilizer.unitOptions;
      delete model.fertilizer.stockyardDisplayUnitOptions;
      delete model.fertilizer.fertiwebCode;
    }

    return model;
  });

  ang.overrideFunction(controller, 'delete', function(baseFn, popupAnswer) {
    if (
      popupAnswer == 'ok' &&
      controller.details.fertilizer &&
      controller.details.fertilizer.sysFertilizer &&
      controller.details.fertilizer.sysFertilizer.id
    ) {
      searchIndex.undoExcludeFromIndex(
        controller.details.fertilizer.sysFertilizer.id
      );
    }

    return baseFn(popupAnswer);
  });
  ang.overrideFunction(controller, 'onItemAdded', function(baseFn, addedItem) {
    excludeFromSearch(addedItem);
  });

  /**
   * Overwrites the function 'propertyChanged' of the coreCommonController if called from the fertilizerCoreController.
   * Sets an array 'dirtyField' into the current fertilizer and adds the name of the field that was changed in FrontEnd.
   */
  ang.overrideFunction(controller, 'propertyChanged', function(
    baseFn,
    fieldName
  ) {
    var model = controller.details.fertilizer;

    if (model) {
      if (!model.dirtyFlags) {
        model.dirtyFlags = [];
      }
      if(fieldName === "fertiwebCode") {
        if(model.fertiwebCode === "") {
          model.vendorId = undefined;
          model.vendorProductId = undefined;
          model.dirtyFlags.push("vendorId");
          model.dirtyFlags.push("vendorProductId");
        } else {
          model.vendorId = "FERTIWEB";
          model.vendorProductId = model.fertiwebCode;
          model.dirtyFlags.push("vendorId");
          model.dirtyFlags.push("vendorProductId");
        }
      } else {
        model.dirtyFlags.push(fieldName);
      }
    }

    return baseFn(fieldName);
  });

  /**
   * Sets the field 'dirtyFlags' to <null> if existent.
   * The dirtyFlags field can be set to the request object in order to give the backend information about changed form fields
   * in the FrontEnd. See also:
   * 'fertilizerCoreCustom.ang.overrideFunction(controller, "propertyChanged", function(baseFn, fieldName))'
   */
  ang.overrideFunction(controller, 'resetDirtyFlags', function() {
    var model = controller.details.fertilizer;
    model.dirtyFlags = null;
  });

  /**
   * Overwrites the function 'handleSaveResponse' of the coreCommonController if called from the fertilizerCoreController.
   * Clears the 'dirtyField' array after it was sent to the BackEnd.
   */
  ang.overrideFunction(controller, 'handleSaveResponse', function(
    baseFn,
    data,
    sentModel
  ) {
    controller.resetDirtyFlags();
    controller.markCurrentStateSaved();

    return baseFn(data, sentModel);
  });

  controller.create = function(e) {
    //create new fertilizer and open details to show it
    controller.callRest('create', true)(null, true);
  };

  var excludeFromSearch = function(sysFertilizer) {
    if (sysFertilizer.type !== 'ORGANIC') {
      searchIndex.excludeFromIndex(sysFertilizer.id);
    }
  };
  var searchIndex = searchService('sysfertilizer', {
    initOnFirstSearch: true,
    sortBy: 'tradeName'
  }).buildIndex({
    fullText: function(sysFertilizer) {
      if (sysFertilizer.isActivated) {
        //exclude from index output but leave it in there, so if the user removes it, it will
        //be immediately available again (without having to reload the whole list again)
        excludeFromSearch(sysFertilizer);
      }
      return [sysFertilizer.tradeName];
    }
  });
  $scope.search = searchIndex.fullTextSearch;
  $scope.searchSelected = function(selectedItem) {
    controller.doAddByTemplate(selectedItem, {
      doNotRefreshIndexList: true,
      openDetails: true
    });
  };

  return controller;
});
